



















































import { Component, Prop, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import AbstractField from '@/app/modules/shared/components/forms/inputs/abstract-field/abstract-field';
import FieldWrapper from './field-wrapper/field-wrapper.vue';
import { Contact } from '@contacts/interfaces/contact';
import { SportSheet } from '@contacts/interfaces/sport-sheet';
import Input from '@shared/components/forms/inputs/input/input.vue';
import Select from '@shared/components/forms/inputs/select/select.vue';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';

library.add(faSync);

@Component({
  name: 'bc-tppwb-tennis-input',
  components: {
    'bpc-field-wrapper': FieldWrapper,
    'bpc-input': Input,
    'bpc-select': Select,
  },
})
export default class TppwbTennisInput extends mixins(AbstractField) {
  sportSheet: SportSheet | null = null;
  options: { value: number; text: string }[] = [];
  syncOptions: { value: string; text: string }[] = [
    { value: 'not_decided_yet', text: this.$t('global.tppwb_sync.not_decided_yet') as string },
    { value: 'to_sync', text: this.$t('global.tppwb_sync.to_sync') as string },
    { value: 'not_to_sync', text: this.$t('global.tppwb_sync.not_to_sync') as string },
  ];
  syncEnabled = 'not_decided_yet';
  externalId: number = 0;
  ranking: string = '';
  active: number = 0;
  syncStatus: string = '';
  errorMessage: string = '';
  tppwbPadelSync: string = '';

  mounted() {
    this.sportSheet = this.formModel?.sport_sheets?.find(sheet => sheet.type === 'padel') || null;
    this.tppwbPadelSync = this.formModel.tppwb_padel_sync || 'not_decided_yet';
    this.options = [
      { value: 1, text: this.$t('global.yes') as string },
      { value: 0, text: this.$t('global.no') as string },
    ];
    this.externalId = this.sportSheet?.external_id || 0;
    this.ranking = this.sportSheet?.ranking || '';
    this.active = this.sportSheet?.active ? 1 : 0;
    this.syncStatus = this.sportSheet?.sync_status || '';
    this.syncEnabled = this.formModel?.tppwb_padel_sync || 'not_decided_yet';
  }
  @Watch('tppwbPadelSync')
  onChangetppwbPadelSync() {
    this.$set(this.formModel, 'tppwb_padel_sync', this.tppwbPadelSync);
  }
}
